/* eslint-disable */
import React, { Component } from 'react'
import { Button, Icon } from 'semantic-ui-react';
import AgGridTable from '../agGrid/agGridTable'
import ReadAxios from '../axiosComponent/readAxios'
import VehicleModal from '../modalComponent/addVehicle';
import ActionButton from './editActionButton'
export default class VehicleTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowItems: [],
            update: false,
            search_value: '',
            loadingData: true,
            open: false,
            mode: '',
            vehicleInfo: {}
        }
    }

    componentDidUpdate(props) {
        if (this.state.update) {
            this.setState({ update: false })
        }
    }

    getVehicleDetials = (data) => {
        let vehicleArra = [...this.state.rowItems]
        let combine = { ...data, id: this.state.rowItems.length }
        vehicleArra.push(combine)
        this.setState({
            rowItems: vehicleArra,
            open: false
        }, () => this.props.gotVehicleData(this.state.rowItems))
    }

    getEditVehicledata = (data) => {
        console.log(">>>", data)
        // let designation = data.designation.split(',')
        let newValues = [...this.state.rowItems]
        newValues[data.id] = {
            ...newValues[data.id],
            vehicleNumber : data.vehicleNumber,
            vehicleTypeId : data.vehicleTypeId,
            vehicleDimensions : data.vehicleDimensions,
            vehicleCapacity : data.vehicleCapacity,
            vehicleGps : data.vehicleGps,
            vehicleBaseLocation : data.vehicleBaseLocation,
            vehiclePUCExpiryDate : data.vehiclePUCExpiryDate,
            vehiclePUCFile : data.vehiclePUCFile,
            vehicleInsuranceExpiryDate : data.vehicleInsuranceExpiryDate,
            vehicleInsuranceFile : data.vehicleInsuranceFile,
            vehicleFitnessCertExpiryDate : data.vehicleFitnessCertExpiryDate,
            vehicleFitnessCertFile : data.vehicleFitnessCertFile,
            vehiclePermitExpiryDate : data.vehiclePermitExpiryDate,
            vehiclePermitFile : data.vehiclePermitFile,
            vehicleRCNo : data.vehicleRCNo,
            vehicleRCNoExpiryDate : data.vehicleRCNoExpiryDate,
            vehicleRoadTaxValidityDate : data.vehicleRoadTaxValidityDate
        }

        this.setState({
            rowItems: newValues,
            open: false
        }, () => {this.props.gotVehicleData(this.state.rowItems)})
    }

    updated = (data) => {
        if (data) {
            this.setState({ update: !this.state.update })
        }
    }
    handleVehicleClose = (data) => {
        this.setState({ open: false })
    }
    editVehicleData = (data) => {
        this.setState({ mode: 'reg_edit', open: true })
        setTimeout(this.setState({ vehicleInfo: data}), 500);
    }

    render() {
        let columnDefs = [
            { headerName: 'Vehicle Number', field: 'vehicleNumber', enableRowGroup: true, enablePivot: true },
            { headerName: 'Vehicle Type', field: 'vehicle_type_name', enableRowGroup: true, enablePivot: true },
            { headerName: 'Dimensions (in FT)', field: 'vehicleDimensions', enableRowGroup: true, enablePivot: true },
            { headerName: 'Capacity (in MT)', field: 'vehicleCapacity', enableRowGroup: true, enablePivot: true },
            { headerName: 'GPS Partner', field: 'vehicleGps', enableRowGroup: true, enablePivot: true },
            { headerName: 'Base Location', field: 'vehicleBaseLocation', enableRowGroup: true, enablePivot: true },
            // { headerName: 'View Details', field: 'details', enableRowGroup: true, enablePivot: true },
            { headerName: 'Edit', field: 'edit', cellRenderer: 'actionRenderer', suppressToolPanel: true },
        ]

        return (
            <div>
                <AgGridTable
                    isLoading={this.state.loadingData}
                    columnDefs={columnDefs}
                    hiddenOEBtn={true}
                    hiddenNew={true}
                    pagination={true}
                    exporthidden={true}
                    importhidden={true}
                    searchbar={true}
                    moreTitleComponents={
                        <Button type="button" onClick={() => this.setState({ open: true, mode: '' })} size="mini" color="blue" basic className="w3-text-white" icon><Icon name="plus" /> New</Button>
                    }
                    loading={this.state.loading}
                    editVehicleData={this.editVehicleData}
                    serverData={this.state.rowItems}
                    titleBarTitle={"Vehicle Details"}
                    actionButton={ActionButton}
                    updated={this.updated}
                    rowData={this.state.rowItems}
                    baseURL={this.props.locationHistory}
                />

                <VehicleModal
                    openBox={this.state.open}
                    vehicleInfo={this.state.vehicleInfo}
                    getvehicledata={this.getVehicleDetials}
                    mode={this.state.mode}
                    updated={this.props.updated}
                    getEditVehicledata={this.getEditVehicledata}
                    handleClose={this.handleVehicleClose}
                />
            </div>
        )
    }
}
